<template>
  <Card class="menu-card">
    <el-menu slot="title" :default-active="activeIndex" mode="horizontal" @select="handleSelect">
      <el-menu-item index="1">员工配方统计</el-menu-item>
      <el-menu-item index="2">员工加工统计</el-menu-item>
    </el-menu>
    <div slot="content">
      <StaffFormulas v-if="menuIndex == 1" />
      <StaffProcess v-if="menuIndex == 2" />
    </div>
  </Card>
</template>

<script lang="js">
import StaffFormulas from "./StaffFormulas.vue"; // 员工配方
import StaffProcess from "./StaffProcess.vue"; // 员工加工
export default {
  name: "StaffFormula",
  components: { StaffFormulas, StaffProcess },
  data() {
    return {
      activeIndex: "1", // 默认激活菜单
      menuIndex: "1", // 菜单索引
    }
  },
  created() {
    let index = this.$session.get('staffFormulaIndex')
    if (index) this.activeIndex = this.menuIndex = index;
  },
  methods:{
    // 切换当前显示组件
    handleSelect(key) {
      this.menuIndex = key;
      this.$session.set('staffFormulaIndex', key);
    }
  }
};
</script>